import React from 'react';
import {Button, Card, Icon} from "@blueprintjs/core";
import {Typography} from "@material-ui/core";
import EmployeeName from "../Employee/EmployeeName";
import ScheduleDateGroup from "./ScheduleDateGroup";
import ReduxStore from "../../ReduxStore";
import {applicationSubmitData} from "../../Actions/ApplicationActions";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";

class ScheduleCard extends React.PureComponent {

  handlePrintPacket = () => {
    ReduxStore.dispatch(applicationSubmitData('timelog/print', {
      'loading': 'Printing Appointment Packet',
      data: {
        inquiry: this.props.inquiry,
        workorder: this.props.id,
      },
    }));
  };

  // Build a map URL that hands off to the device's native map app:
  //  - iOS  -> Apple Maps (always installed; iOS has no "open with" chooser).
  //  - Android -> geo: URI, which lets the OS open whichever map app the user
  //    prefers (Google Maps, Waze, etc.) instead of forcing one.
  //  - Everything else (desktop) -> Google Maps in the browser.
  getDirectionsUrl = (address) => {
    const destination = encodeURIComponent(address);
    const ua = navigator.userAgent;
    const isApple = /iPad|iPhone|iPod/.test(ua)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if ( isApple ) {
      return "https://maps.apple.com/?daddr=" + destination;
    }
    if ( /Android/.test(ua) ) {
      return "geo:0,0?q=" + destination;
    }
    return "https://www.google.com/maps/dir/?api=1&destination=" + destination;
  };

  handleDocumentDownload = () => {
    const {documentName, documentPath} = this.props;
    let link = window.document.createElement('a');
    link.href = documentPath;
    link.target = '_blank';
    link.download = documentName;
    link.click();
  };

  render() {
    const {id, inquiry, title, customer, address, type, employees, schedule, phones, documentPath, notes, coordinator} = this.props;

    let icon;
    if ( type === 'install' ) {
      icon = (<Icon icon="build" />)
    } else if ( type === 'meeting' ) {
      icon = (<Icon icon="chat" />)
    } else {
      icon = (<Icon icon="search" />)
    }

    let employeeNames = [];
    employees.forEach((id) => {
      employeeNames.push(
        <EmployeeName id={id} key={id}/>
      );
    });

    let phoneNumbers = [];
    if ( phones && phones.length ) {

      phones.forEach((phone) => {
        phoneNumbers.push(

            <ListItem dense key={phoneNumbers.length} disableGutters>
              <ListItemText primary={phone.formatted} />
              <ListItemText secondary={phone.type_label} secondaryTypographyProps={{align: 'right'}} />
            </ListItem>

        );
      });

    }

    const phoneList = (
      <List
        dense
        disablePadding={true}
        subheader={
          <ListSubheader component={'div'} disableGutters disableSticky color={'primary'}>
            {customer}
          </ListSubheader>
        }
      >
        {phoneNumbers}
      </List>
    );


    let dates = [];
    Object.keys(schedule).forEach((dateKey) => {
      const dateGroup = schedule[dateKey];
      dates.push(
        <ScheduleDateGroup key={dateKey} group={dateGroup}/>
      )
    });

    let downloadButton = '';
    if ( documentPath ) {
      downloadButton = (
        <Button
          intent={"success"}
          icon={"download"}
          onClick={this.handleDocumentDownload}
        >Download</Button>
      );
    }
    
    
    let noteDisplay;
    if ( !!notes ) {
      noteDisplay = (
        <div>
          <br/>
          <div dangerouslySetInnerHTML={{__html: notes}}/>
        </div>
      );
    }


    return (
      <Card elevation={1} className="scheduleCard">
        {!!inquiry && type === 'task' && <Typography component="h5">
          {icon} <b>#{inquiry} {title}</b>
        </Typography>}
        {!!inquiry && type !== 'task' && <Typography component="h5">
          {icon} <b>#{inquiry}-{id} {title}</b>
        </Typography>}
        {!inquiry && <Typography component="h5">
          {icon} <b>{title}</b>
        </Typography>}
        <Typography variant="body2">
          {address}
        </Typography>
        {noteDisplay}
        <br/>
        {phoneList}
        <br/>
        {!!coordinator && <><Typography variant={"body2"}>
          <Icon icon="user"/> <b>Coordinator:</b> {coordinator}
        </Typography><br/></>}
        {dates}
        
        {!!inquiry && type !== 'task' && <Button
          intent={"primary"}
          icon={"print"}
          onClick={this.handlePrintPacket}
        >Print Packet</Button>}
        {" "}
        {downloadButton}
        {" "}
        {!!address &&<a href={this.getDirectionsUrl(address)} target={"_blank"}>
         <Button as={"a"} icon={"map"} intent={"danger"} >
          Directions
        </Button></a>}
      </Card>
    )
  }
}

export default ScheduleCard;
